import { Injectable } from '@angular/core';
import { Router, CanLoad, CanActivate } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanLoad, CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canLoad(): boolean {
    return this.checkLogin();
  }
  canActivate(): boolean {
    return this.checkLogin();
  }
  checkLogin(): boolean {
    if (this.authService.loggedIn()) { return true; }
    localStorage.clear();
    this.router.navigateByUrl('/u/login');
    return false;
  }
}
